import {chakra, Flex} from '@chakra-ui/react';

export const FilterSentence = chakra(Flex, {
  baseStyle: {
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: '16px',
  },
});
